import styled from '@emotion/styled'

export const ReportsNavigationTabsWrapper = styled.div``
